export default __webpack_public_path__ + "static/media/erin.c9932b83.png";